import { render } from "./SimuladorDeConsumo.vue?vue&type=template&id=b3fac7ac"
import script from "./SimuladorDeConsumo.vue?vue&type=script&lang=js"
export * from "./SimuladorDeConsumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__